<h3 mat-dialog-title> Editar Imagen </h3>

<div mat-dialog-content>
    <div class="main-container">
        <div class="options-container">
            <section class="options-section">
                <button class="option-button" matTooltip="Rotar 90° izquierda" (click)="rotateLeft()">
                    <mat-icon>rotate_90_degrees_ccw</mat-icon>
                </button>
                <button class="option-button" matTooltip="Rotar 90° derecha" (click)="rotateRight()">
                    <mat-icon>rotate_90_degrees_cw</mat-icon>
                </button>
                <button class="option-button" matTooltip="Voltear Horizontal" (click)="flipHorizontal()">
                    <mat-icon>flip</mat-icon>
                </button>
                <button class="option-button" matTooltip="Voltear Vertical" (click)="flipVertical()">
                    <mat-icon style="transform: rotate(90deg)">flip</mat-icon>
                </button>
                <button class="option-button" matTooltip="Aumentar Zoom" (click)="zoomIn()">
                    <mat-icon>zoom_in</mat-icon>
                </button>
                <button class="option-button" matTooltip="Reducir Zoom" (click)="zoomOut()" [disabled]="disableZoomOut()">
                    <mat-icon disabled>zoom_out</mat-icon>
                </button>
            </section>
            <section class="options-section">
                <button *ngIf="!this.data.disableAspectRatioButton" class="option-button ratio-button" matTooltip="Cambiar el Ratio de Aspecto" cdkMenuItem [cdkMenuTriggerFor]="ratio">
                    <span>{{ selectedAspectRatio.label }}</span>
                </button>
                
                <button *ngIf="!this.data.disableOrientationButton" class="option-button" 
                    [matTooltip]="orientation ? 'Cambiar a Vertical' : 'Cambiar a Horizontal'" (click)="toggleOrientation()">
                    <mat-icon mat-icon>{{orientation ? 'crop_portrait':'crop_16_9'}}</mat-icon>
                </button>
                
                <button class="option-button"
                    [matTooltip]="containWithinAspectRatio 
                        ? 'Contener dentro de Ratio de Aspecto' 
                        : 'Rellenar Ratio de Aspecto '" 
                    (click)="toggleContainWithinAspectRatio()"
                >
                    <mat-icon>{{containWithinAspectRatio ? 'zoom_in_map' : 'zoom_out_map'}}</mat-icon>
                </button>
            </section>
            <section class="options-section">
                <button class="option-button" matTooltip="Mover izquierda" (click)="moveLeft()">
                    <mat-icon>arrow_left</mat-icon>
                  </button>
                  <button class="option-button" matTooltip="Mover Arriba" (click)="moveTop()">
                    <mat-icon>arrow_drop_up</mat-icon>
                  </button>
                  <button class="option-button" matTooltip="Mover Abajo" (click)="moveBottom()">
                    <mat-icon>arrow_drop_down</mat-icon>
                  </button>
                  <button class="option-button" matTooltip="Mover Derecha" (click)="moveRight()">
                      <mat-icon>arrow_right</mat-icon>
                  </button>
                  <button class="option-button" matTooltip="Reiniciar Cambios" (click)="resetImage()">
                    <mat-icon>restart_alt</mat-icon>
                  </button>
            </section>
        </div>
        <hr class="divider">
        <div class="cropper-container">
            <image-cropper
                [(transform)]="transform"
                [canvasRotation]="canvasRotation"
                [alignImage]="'center'"
                [allowMoveImage]="false"
                [cropperMinWidth]="128"
                backgroundColor="white"
                [containWithinAspectRatio]="containWithinAspectRatio"
                [imageFile]="data.image"
                [maintainAspectRatio]="true"
                [aspectRatio]="aspectRatio"
                [resizeToHeight]="data.height"
                [resizeToWidth]="data.width"
                output="blob"
                format="jpeg"
                (imageCropped)="imageCropped($event)"
            ></image-cropper>
            <div *ngIf="loading" class="cropper-loader">
              <app-loading></app-loading>
            </div>    
        </div>
    </div>
</div>

<div mat-dialog-actions align="end">
    <button mat-raised-button [mat-dialog-close]="false">
        Cancelar
    </button>
    <button type="button" (click)="submit()" mat-raised-button color="primary" [disabled]="submitLoading || result === undefined">
        <mat-icon [class.animate-spin]="submitLoading">{{ submitLoading ? 'autorenew' : 'save' }}</mat-icon>
        Guardar
    </button>
</div>

<!-- Menú Aspect Ratio -->
<ng-template #ratio>
    <div class="ratio-menu" cdkMenu>
        <button *ngFor="let ratio of aspectRatioConf"
            [ngClass]="selectedAspectRatio.label === ratio.label ? 'active' : ''"
            class="ratio-menu-item" 
            (click)="toggleAspectRatio(ratio.label)"
        >
            {{ratio.label}}
        </button>
    </div>
</ng-template>